import { AxiosInstance } from "axios"

export const getLookupProjectStatus = async (api: AxiosInstance): Promise<any> => {
  try {
    const res = await api.get(`api/admin/ProjectStatus/GetLookup`)
    return res.data
  } catch (error) {}
}
